import React from 'react';

const AboutDescription = () => {
  return (
    <div className="top-beam">
      <div className="row">
        <div className="col">
          <div className="subtitle without bigger">
            Software services for the new decade
            <div className="extra">
              Ulam Labs provides full-scope software development support for the
              complete product lifecycle of web and mobile applications. Whether
              you want to create a simple component or a fully-fledged
              enterprise application, we have the skills and experience to build
              it for you and with you.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutDescription;
